// Before Login URL //

export const unAuthorizedUrl = [ 'login', 'forget_password', 'reset_password' ]

// After Login URL //

export const authorizedUrl = [  ]

